import { Button, Header, Text } from '@crossfit/design-system'
import style from './style.module.scss'
import { Link } from 'react-router-dom'
import { useIsMobile } from 'hooks/useMediaQuery'
import Modal from 'react-modal'
import Camera from './camera.svg'
import Pencil from './pencil.svg'

export type ScheduleGuideProps = {
  close: () => void
}

export default function ScheduleGuide({ close }: ScheduleGuideProps) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <Modal
        style={{
          overlay: {
            zIndex: 10,
            backgroundColor: 'rgba(0, 0, 0, .7)',
          },
          content: {
            position: 'fixed',
            top: 'auto',
            left: '50%',
            bottom: '0',
            transform: 'translateX(-50%)',
            width: '100%',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
          },
        }}
        appElement={document.getElementById('app') as HTMLElement}
        isOpen
        onRequestClose={close}
        shouldCloseOnOverlayClick={true}
      >
        <div className={style.mainHeaderContainer}>
          <Header size='md' as={'h1'} className={style.header}>
            Schedule Guide
          </Header>
          <div onClick={close}>
            <Text type='body' size='md' className={style.x}>
              X
            </Text>
          </div>
        </div>
        <div className={style.existingSchedule}>
          <div className={style.headerContainer}>
            <img src={Camera} className={style.icon} />
            <Text size='md' type='body'>
              Use Existing Schedule
            </Text>
          </div>
          <div className={style.link}>
            <ul style={{ listStyleType: 'disc', marginLeft: '20px' }}>
              <li>
                <p style={{ fontSize: '12px' }}>
                  <Link to={'/'} style={{ textDecoration: 'underline' }}>
                    Take a screenshot{' '}
                  </Link>
                  of your schedule and upload the image
                </p>
              </li>
            </ul>
          </div>
        </div>
        <Header as={'h2'} size={'xs'}>
          OR
        </Header>
        <div className={style.newSchedule}>
          <div className={style.headerContainer}>
            <img src={Pencil} className={style.icon} />
            <Text size='md' type='body'>
              Build New Schedule on Canva
            </Text>
          </div>
          <div className={style.link}>
            <ul
              style={{
                listStyleType: 'disc',
                marginLeft: '20px',
                fontSize: '12px',
              }}
            >
              <li>
                <p>
                  Open this
                  <a
                    href='https://www.canva.com/design/DAF7fhwBr_Q/rluEtIdfVjZmO6kwwIkHdw/view?amp&amp&amp&amp&mode=preview&utm_source=integration_slack&utm_medium=referral&utm_content=T024ZS4RC&utm_campaign=unfurl_document-url_open-in-canva_hyperlink&utm_term=fa28ada0-e4c3-41d9-9c77-be0d22f347cf'
                    style={{ textDecoration: 'underline' }}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {' '}
                    Canva template{' '}
                  </a>
                  (a free Canva account will be needed)
                </p>
              </li>
              <li>
                Edit the classes by clicking inside each rectangle. Update the
                times and move the rectangles to match your class schedule
              </li>
              <li>
                <Link
                  to={
                    'https://www.canva.com/help/download-or-purchase/#:~:text=On%20the%20editor%20menu%20bar,file%20type%20for%20your%20download.'
                  }
                  style={{ textDecoration: 'underline' }}
                >
                  Download the file
                </Link>{' '}
                as a .png or .jpeg
              </li>
            </ul>
          </div>
        </div>
        {!isMobile && (
          <div className={style.bottomBar}>
            <Button
              variant='secondary'
              style={{
                color: 'black',
                borderColor: 'black',
                paddingTop: '8px',
                paddingBottom: '8px',
              }}
              onClick={close}
            >
              Close
            </Button>
          </div>
        )}
      </Modal>
    )
  }

  return (
    <div className={style.backdrop} onClick={close}>
      <div className={style.modalContent}>
        <div className={style.headerContainer}>
          <Header size='md' as={'h1'} className={style.header}>
            Schedule Guide
          </Header>
        </div>
        <div className={style.existingSchedule}>
          <div className={style.headerContainer}>
            <img src={Camera} className={style.icon} />
            <Text size='md' type='body'>
              Use Existing Schedule
            </Text>
          </div>
          <div className={style.link}>
            <ul style={{ listStyleType: 'disc', marginLeft: '20px' }}>
              <li>
                <p style={{ fontSize: '12px' }}>
                  <Link to={'/'} style={{ textDecoration: 'underline' }}>
                    Take a screenshot{' '}
                  </Link>
                  of your schedule and upload the image
                </p>
              </li>
            </ul>
          </div>
        </div>
        <Header as={'h2'} size={'xs'}>
          OR
        </Header>
        <div className={style.newSchedule}>
          <div className={style.headerContainer}>
            <img src={Pencil} className={style.icon} />
            <Text size='md' type='body'>
              Build New Schedule on Canva
            </Text>
          </div>
          <div className={style.link}>
            <ul
              style={{
                listStyleType: 'disc',
                marginLeft: '20px',
                fontSize: '12px',
              }}
            >
              <li>
                <p>
                  Open this
                  <a
                    href='https://www.canva.com/design/DAF7fhwBr_Q/rluEtIdfVjZmO6kwwIkHdw/view?amp&amp&amp&amp&mode=preview&utm_source=integration_slack&utm_medium=referral&utm_content=T024ZS4RC&utm_campaign=unfurl_document-url_open-in-canva_hyperlink&utm_term=fa28ada0-e4c3-41d9-9c77-be0d22f347cf'
                    style={{ textDecoration: 'underline' }}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {' '}
                    Canva template{' '}
                  </a>
                  (a free Canva account will be needed)
                </p>
              </li>
              <li>
                Edit the classes by clicking inside each rectangle. Update the
                times and move the rectangles to match your class schedule
              </li>
              <li>
                <Link
                  to={
                    'https://www.canva.com/help/download-or-purchase/#:~:text=On%20the%20editor%20menu%20bar,file%20type%20for%20your%20download.'
                  }
                  style={{ textDecoration: 'underline' }}
                >
                  Download the file
                </Link>{' '}
                as a .png or .jpeg
              </li>
            </ul>
          </div>
        </div>
        <div className={style.bottomBar}>
          <Button
            variant='secondary'
            style={{
              color: 'black',
              borderColor: 'black',
              paddingTop: '8px',
              paddingBottom: '8px',
            }}
            onClick={close}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}
